import { purchasedProductsStyles as styles } from "@insite/content-library/Widgets/Common/PurchasedProducts";
import { css } from "styled-components";

styles.headerContainer = {
    ...styles.headerContainer,
    offsetCss: css`
        justify-content: space-between;
    `,
}